import React from 'react';
import { Spinner } from '../theme/primitives';

export const Loading = ({ label = 'Loading' }) => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
    <div className="relative flex h-14 w-14 items-center justify-center">
      <span aria-hidden className="absolute inset-0 rounded-full bg-amber/15 animate-ping" />
      <span aria-hidden className="absolute inset-2 rounded-full bg-amber/8" />
      <Spinner size={28} />
    </div>
    <div className="text-[10.5px] font-bold uppercase tracking-[0.22em] text-amber">
      {label}
    </div>
  </div>
);
